import styled from 'styled-components';
import { Card } from '@mui/material';

export const StyledCard = styled(Card)`
  && {
    border-radius: 30px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12),
      0px 1px 3px rgba(0, 0, 0, 0.2);
  }
`;